import React from 'react';

export default function Footer() {
  const scrollToSection = (id: string) => {
    try {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.error(`Failed to scroll to section "${id}":`, error);
    }
  };

  return (
    <footer className="bg-[#f0ece6] border-t border-[#00D9FF]/30 py-10 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 mb-8 sm:mb-12">
          {/* Left Column - Brand */}
          <div>
            <h3 className="text-[#1a1a1a] text-xl sm:text-2xl font-bold mb-2">
              James Moore
            </h3>
            <p className="text-gray-600 text-base sm:text-lg mb-4">
              Authentic Stories. Real Results.
            </p>
            <p className="text-gray-500 text-xs sm:text-sm">
              &copy; 2025 James Moore. All Rights Reserved
            </p>
          </div>

          {/* Center Column - Quick Links */}
          <div>
            <h4 className="text-[#1a1a1a] font-bold text-sm sm:text-base mb-4 sm:mb-5 uppercase tracking-wider">
              <a href="#quick-links" className="hover:text-[#00D9FF] transition-colors duration-300">
                Quick Links
              </a>
            </h4>
            <div className="flex flex-wrap gap-x-6 gap-y-3">
              {[
                { label: 'Work', id: 'work' },
                { label: 'About', id: 'about' },
                { label: 'Testimonials', id: 'testimonials' },
                { label: 'Contact', id: 'contact' },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-gray-700 text-sm uppercase tracking-widest hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer"
                >
                  {link.label}
                </button>
              ))}
              <a
                href="#media-kit"
                className="text-gray-700 text-sm uppercase tracking-widest hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer"
              >
                Media Kit
              </a>
            </div>
          </div>

          {/* Right Column - Stay Connected */}
          <div>
            <h4 className="text-[#1a1a1a] font-bold text-sm sm:text-base mb-4 sm:mb-5 uppercase tracking-wider">
              <a href="#stay-connected" className="hover:text-[#00D9FF] transition-colors duration-300">
                Stay Connected
              </a>
            </h4>
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-line', url: 'https://instagram.com', label: 'Instagram' },
                { icon: 'ri-tiktok-line', url: 'https://tiktok.com', label: 'TikTok' },
                { icon: 'ri-youtube-line', url: 'https://youtube.com', label: 'YouTube' },
                { icon: 'ri-linkedin-line', url: 'https://linkedin.com', label: 'LinkedIn' },
                { icon: 'ri-twitter-x-line', url: 'https://twitter.com', label: 'X' },
                { icon: 'ri-mail-line', url: 'mailto:james@jamesmoore.com', label: 'Email' },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-gray-700 hover:bg-[#00D9FF] hover:border-[#00D9FF] hover:text-black transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-gray-300 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <div className="flex items-center gap-3 sm:gap-4 text-gray-500 text-xs sm:text-sm">
            <a href="#privacy" className="hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="#terms" className="hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
